import { SalesState } from 'src/types/redux';
import {
  FETCH_SALES_SUCCESS,
  FETCH_SALES_FAILURE,
  FETCH_SALES_REQUEST,
  FETCH_ORDER_TYPES_SUCCESS,
  FETCH_PAYMENT_SUCCESS,
  SalesActionType,
} from '../types/salesType';

const initialState: SalesState = {
  error: '',
  loading: false,
  salesData: {
    floors: [],
    orders: [],
    customers: [],
    deliveryPartners: [],
    taxes: [],
    websiteOrders: [],
  },
  orderType: {},
  payments: [],
};

export const salesReducer = (
  state = initialState,
  action: SalesActionType
): SalesState => {
  switch (action?.type) {
    case FETCH_SALES_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        salesData: action?.payload,
      };
    case FETCH_PAYMENT_SUCCESS:
      return {
        ...state,
        payments: action?.payload,
      };
    case FETCH_ORDER_TYPES_SUCCESS:
      return {
        ...state,
        orderType: action?.payload,
      };
    case FETCH_SALES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
